import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-bottom-black.png'


const _withScopeId = n => (_pushScopeId("data-v-b7edd65a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-history-item" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-box" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "action-box" }
const _hoisted_7 = { class: "link-history" }
const _hoisted_8 = { class: "list" }
const _hoisted_9 = { class: "row header" }
const _hoisted_10 = {
  key: 0,
  class: "row cells"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "mobile-list" }
const _hoisted_14 = {
  key: 0,
  class: "card"
}
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { class: "content" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "item" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = {
  key: 0,
  class: "item"
}
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "content" }
const _hoisted_33 = { class: "item" }
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "content" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 1 }

import { ref, computed } from 'vue';
import { IUserRequest, UserRequestProgramShipment } from '@/types/user-request';
import { useI18n } from 'vue-i18n';
import dayjs from 'dayjs';
import { ColorVariants, PROGRAM_SHIPMENTS_STATE_LIST } from '@/constants';
import { confirm, request, alert, requestCollection } from '@/utils';
import _ from 'lodash';
import { useToast } from 'bootstrap-vue-3';
import PickupPopup from '@/templates/on-going-program/components/apply-button/pickup-popup.vue';
import { usePickupPopup } from '@/hooks/use-pickup-popup';

interface Props {
  modelValue: IUserRequest;
  role: string | undefined;
}

interface Emits {
  (event: 'update'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    role: null
  },
  emits: ["update"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: IUserRequest;
  role: string | undefined;
}



const { t, locale } = useI18n();

const pickupPopupRef = ref();

// 使用 hook 判断是否应该显示 pickup popup
const { shouldShowPickupPopup } = usePickupPopup(() => props.modelValue.target);

// 根据是否显示 Filter Quantity 列来动态计算列宽
const columnClass = computed(() => {
  // 如果显示 Filter Quantity 列，则有 7 列，否则 6 列
  return shouldShowPickupPopup.value ? 'col' : 'col-2';
});

const isKo = locale.value === 'ko';
const programShipments = computed(() => {
  if (!Array.isArray(props.modelValue.program_shipments)) {
    return [];
  }
  return props.modelValue.program_shipments as UserRequestProgramShipment[];
});
const stateList = PROGRAM_SHIPMENTS_STATE_LIST;
function getStateName(shipment: UserRequestProgramShipment) {
  const state = shipment.state;
  const index = stateList.findIndex(item => item.state.includes(state));
  if (index === -1) {
    return state;
  }
  const item = stateList[index];
  if (!isKo || index !== 0) {
    return item.name;
  }
  return item.name;
}

const fixedLen = 3;
const showLen = ref(fixedLen);
function handleShowMore() {
  showLen.value = showLen.value === fixedLen ? programShipments.value.length : fixedLen;
}

// 回收类型，线上、线下
const targetShowTypes = computed(() => {
  return props.modelValue.target?.program_detail_info_attributes?.show_types || [];
});
// 是否包含线上
const hasOnlineShowType = computed(() => {
  return targetShowTypes.value.includes('online');
});
// 是否包含线下
const hasOfflineShowType = computed(() => {
  return targetShowTypes.value.includes('offline');
});

// const collectionHistoryJump = computed(() => {
//   // 韩国这几个OnGoingProgram要特殊处理
//   // https://www.terracycle-kr.com/programs/gpzw_collectionD
//   // https://www.terracycle-kr.com/programs/gpzw_collectionC
//   // https://www.terracycle-kr.com/programs/gpzw_collectionB
//   // https://www.terracycle-kr.com/programs/gpzw_collectionA
//   const targetId = props.modelValue?.target?.id;
//   if (locale.value === 'ko' && [3, 4, 5, 6].includes(targetId)) {
//     return ['approved', 'closed'].includes(props.modelValue.state);
//   }
//   // B2始终可以点击
//   if (props.role === 'store_sub') {
//     return true;
//   }
//   // 通过了审核或者关闭的才可以走后续判断
//   if (!['approved', 'closed'].includes(props.modelValue.state)) {
//     return false;
//   }
//   // C 有线上提交记录保持点击，或者当前tab有线上可以点击
//   return props.modelValue.has_online_collection_requests || hasOnlineShowType.value;
// });

const ocCollectionHistoryJump = computed(() => {
  // B2始终不可以点击
  if (props.role === 'store_sub') {
    return false;
  }
  // 通过了审核或者关闭的才可以走后续判断
  if (!['approved', 'closed'].includes(props.modelValue.state)) {
     return false;
  }
  // C 有提交记录保持点击
  if (props.modelValue.has_offline_collection_requests) {
    return true;
  }
  // C 有线下提交记录保持点击、或者当前tab有线下可以点击
  return props.modelValue.has_offline_collection_requests || hasOfflineShowType.value;
});

const showRequestCollection = computed(() => {
  const { state, target } = props.modelValue;
  const isEnd = target.ended_at ? dayjs(target.ended_at).isBefore(dayjs()) : false;
  // B2在个人中心的program参加列表，一直显示线上回收按钮。除非取消参加
  if (props.role === 'store_sub') {
    return state !== 'closed';
  }
  // admin配置了隐藏按钮，普通用户走这个判断，同详情
  if (target.hide_collection_btn) {
    // 如果配置了隐藏按钮，普通用户要返回false(不显示)
    return !(props.role !== 'store_sub' || !target.is_pdo_of_program);
  }
  // 线下回收不显示回收按钮(PDO例外)
  return (hasOnlineShowType.value || target.is_pdo_of_program) && (target.type === 'OnGoingProgram' && (!isEnd) && state === 'approved');
});

function getDate(date: string) {
  if (!date) {
    return '/';
  }
  return dayjs(date).format('YYYY-MM-DD');
}

async function handleCancelCollection(id: number) {
  await confirm(t('Confirm cancellation?'));
  await request.post(`program_shipments/${id}/cancel`);
  alert({ title: t('Success'), content: t('Operation success'), });
  emits('update');
}

const toast = useToast();
async function handleRequest() {
  // 检查是否需要显示 BRITA pickup popup
  if (shouldShowPickupPopup.value) {
    if (pickupPopupRef.value) {
      pickupPopupRef.value.show();
    }
    return;
  }

  // 原有逻辑：直接调用 requestCollection
  await executeRequest();
}

function handlePickupConfirm(variableNumber: number) {
  // 用户确认数量，调用 executeRequest 并传入数量
  executeRequest(variableNumber);
}

function handlePickupCancel() {
  // 用户取消，不执行任何操作
}

async function executeRequest(variableNumber?: number) {
  const program = props.modelValue.target;
  try {
    const result = await requestCollection(program, variableNumber);
    if (result) {
      if (result.status === 'success') {
        toast.show({ title: t('on_going_program_apply_success_content') }, { variant: ColorVariants.success });
      }
      if (result.status === 'wait_list') {
        toast.show({ title: t('on_going_program_join_waiting_list_success_content') }, { variant: ColorVariants.info });
      }
    }
    emits('update');
  } catch (e) {
    const errorMsg = _.get(e, 'message');
    toast.show({ title: errorMsg });
    throw e;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_AppCustomLink = _resolveComponent("AppCustomLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(shouldShowPickupPopup))
      ? (_openBlock(), _createBlock(PickupPopup, {
          key: 0,
          ref_key: "pickupPopupRef",
          ref: pickupPopupRef,
          "minimum-number": __props.modelValue.target.minimum_variable_number || 12,
          onConfirm: handlePickupConfirm,
          onCancel: handlePickupCancel
        }, null, 8, ["minimum-number"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.modelValue.target.image?.url,
        class: "cover"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.modelValue.target.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (__props.modelValue.has_offline_collection_requests && _unref(ocCollectionHistoryJump))
          ? (_openBlock(), _createBlock(_component_AppCustomLink, {
              key: 0,
              to: { name: 'oc_user_requests.detail', params: { id: __props.modelValue.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_7, _toDisplayString(_unref(t)('Offline collection')), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_unref(showRequestCollection))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "request-btn",
              onClick: handleRequest
            }, _toDisplayString(_unref(t)('request_collection')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(_unref(columnClass))
        }, _toDisplayString(_unref(t)('Request Date')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(columnClass))
        }, _toDisplayString(_unref(t)('Recycle request record')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(columnClass))
        }, _toDisplayString(_unref(t)('Logistics number')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(columnClass))
        }, _toDisplayString(_unref(t)('Arrival Date')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(columnClass))
        }, _toDisplayString(_unref(t)('Weight')), 3),
        (_unref(shouldShowPickupPopup))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_unref(columnClass))
            }, _toDisplayString(_unref(t)('Filter Quantity')), 3))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(columnClass))
        }, _toDisplayString(_unref(t)('Status')), 3)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programShipments), (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.id
        }, [
          (i < showLen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(columnClass))
                }, _toDisplayString(getDate(item.created_at)), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(columnClass))
                }, _toDisplayString(item.tracking_number || '/'), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(columnClass))
                }, _toDisplayString(item.no || '/'), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(columnClass))
                }, _toDisplayString(getDate(item.received_at)), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(columnClass))
                }, _toDisplayString(item.collected_item.weight || '/'), 3),
                (_unref(shouldShowPickupPopup))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_unref(columnClass))
                    }, _toDisplayString(item.collection_request?.variable_number || '/'), 3))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(_unref(columnClass))
                }, [
                  (item.show_cancel_btn)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "cancel",
                        onClick: ($event: any) => (handleCancelCollection(item.id))
                      }, _toDisplayString(_unref(t)('Cancel')), 9, _hoisted_11))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(getStateName(item)), 1))
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      (_unref(programShipments).length > fixedLen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "arrow-box",
            onClick: handleShowMore
          }, [
            _createElementVNode("img", {
              class: _normalizeClass(["arrow", { top: showLen.value !== fixedLen }]),
              src: _imports_0
            }, null, 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(programShipments), (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (i < showLen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('Request Date')), 1),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(getDate(item.created_at)), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('Recycle request record')), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(item.tracking_number || '/'), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('Logistics number')), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(item.no || '/'), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('Arrival Date')), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(getDate(item.received_at)), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('Weight')), 1),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(item.collected_item.weight || '/'), 1)
                ]),
                (_unref(shouldShowPickupPopup))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)('Filter Quantity')), 1),
                      _createElementVNode("div", _hoisted_32, _toDisplayString(item.collection_request?.variable_number || '/'), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('Status')), 1),
                  _createElementVNode("div", _hoisted_35, [
                    (item.collection_request.show_cancel_btn)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "cancel",
                          onClick: ($event: any) => (handleCancelCollection(item.id))
                        }, _toDisplayString(_unref(t)('Cancel')), 9, _hoisted_36))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(getStateName(item)), 1))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      (_unref(programShipments).length > fixedLen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "arrow-box",
            onClick: handleShowMore
          }, [
            _createElementVNode("img", {
              class: _normalizeClass(["arrow", { top: showLen.value !== fixedLen }]),
              src: _imports_0
            }, null, 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})